import { GridViewIcon } from 'ui-components/dist/GridViewIcon';
import { ViewGridIcon, ViewListIcon } from '~/components/icons';
import { VIEW_OPTIONS } from '~/constants';
import { CONTENT_SEARCH_ROSTER } from '~/hooks/useContentSearch';
import { SORT } from '~/searchApi/content';

import { ISearchContentQuery } from './SearchContent.types';

export const PAGE_SIZE = 32;

export enum SEARCH_PROP {
  ads = 'ads',
  creator = 'creator',
  page = 'page',
  channel = 'channel',
  page_size = 'page_size',
  platform = 'platform',
  query = 'query',
  roster = 'roster',
  sort = 'sort',
  sortBy = 'sortBy',
  view = 'view',
  fuzzy = 'fuzzy',
  postedAfter = 'postedAfter',
  postedBefore = 'postedBefore',
}
export enum PLATFORM_OPTIONS {
  all = 'All',
}

export const VIEW_OPTIONS_ICON = {
  list: ViewListIcon,
  grid: ViewGridIcon,
  card: GridViewIcon,
} as const;

export const FILTER_DEFAULTS: Required<
  Pick<
    ISearchContentQuery,
    | SEARCH_PROP.page
    | SEARCH_PROP.roster
    | SEARCH_PROP.sortBy
    | SEARCH_PROP.view
  >
> = {
  page: '1',
  roster: CONTENT_SEARCH_ROSTER.agency,
  sortBy: SORT.mostRecent,
  view: VIEW_OPTIONS.grid,
} as const;

export const GLOBAL_FILTER_DEFAULTS: Required<
  Pick<
    ISearchContentQuery,
    | SEARCH_PROP.page
    | SEARCH_PROP.roster
    | SEARCH_PROP.sortBy
    | SEARCH_PROP.view
  >
> = {
  page: '1',
  roster: CONTENT_SEARCH_ROSTER.agency,
  sortBy: SORT.relevance,
  view: VIEW_OPTIONS.grid,
} as const;
